const ColorData = {
  primary: {
    main: "#a24857",
    strokeColor: "#ffffff80", // Semi-transparent white for stroke
  },
  secondary: {
    main: "#F3EAE0",
  },
  accent: {
    main: "#a24857", // --accent-color (same as primary)
  },
  background: {
    default: "#fff", // --background-color
  },
  custom: {
    white: "#ffffff", // --white-color
    black: "#000000", // --black-color
  },
  text: {
    primary: "#000000", // --text-color
    secondary: "#ffffff", // --text-color-2
  },
  heading: {
    main: '#a24857', // --heading-color
    contrast: '#000000', // --heading-color-2
  },
  hover: {
    main: '#bf5567', // --hover-color
  },
  stroke: {
    main: '#D4D4D4', // --stroke-color
    faint: '#ffffff80', // --f-stroke-color
  },
};

export default ColorData;
